jQuery(document).ready(function ($) {
    // Handle form submission
    $('.inline-newsletter-form-wrapper').on('submit', function (e) {
        e.preventDefault();

        var form = $(this);
        var emailField = form.find('.newsletter-email');
        var submitBtn = form.find('#inline-rul-submit-btn');
        var loader = form.find('.inline-rul-loader');
        var successMessage = form.find('.inline-newsletter-success');
        var successText = form.find('.inline-success-message');
        var email = emailField.val().trim();

        var emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

        if (email === '') {
            showErrorMessage(form, 'Please enter your email.');
            return;
        }

        if (!emailRegex.test(email)) {
            showErrorMessage(form, 'Please enter a valid email.');
            return;
        }

        // Show the loading state
        submitBtn.addClass('inlineloading');
        loader.show();

        $.ajax({
            url: rulNewsletterData.rest_url,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-WP-Nonce': rulNewsletterData.nonce
            },
            data: JSON.stringify({
                email: email
            }),
            success: function (response) {
                // Show success message
                successText.text('Thanks for signing up!');
                successMessage.css({
                    'opacity': '1',
                    'visibility': 'visible',
                    'color': '' // Reset to default color
                });
                emailField.val(''); // Clear input field
            },
            error: function (xhr, status, error) {
                var errorMessage = 'Failed! Please try again.';
                if (xhr.responseJSON && xhr.responseJSON.message) {
                    errorMessage = xhr.responseJSON.message;
                }
                showErrorMessage(form, errorMessage);
            },
            complete: function () {
                submitBtn.removeClass('inlineloading');
                loader.hide();
            }
        });
    });

    function showErrorMessage(form, message) {
        var successMessage = form.find('.inline-newsletter-success');
        var successText = form.find('.inline-success-message');
        
        successText.text(message);
        successMessage.css({
            'opacity': '1',
            'visibility': 'visible',
            'color': '#ff6b6b' // Light red color for errors
        });
    }
});